<mat-card class="mat-elevation-z0">
    <mat-card-title class="header">
        <h3 appLocalizationPopupDirective localizationCode="TOILPolicies">{{ 'TOILPolicies' | translate: {Default: "TOIL Policies"} }}</h3>
        <div>
            <button class="add-policy-button" mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="openAssignPolicyDialog()" *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="AddAPolicy">
                <mat-icon class="material-icons-outlined" >add</mat-icon>
                {{ 'AddAPolicy' | translate: {Default: "Add A Policy"} }}
            </button>
        </div>
    </mat-card-title>
    <mat-card-content>
        <div *ngIf="employeeToilPolicies$ | withLoading | async as employeeToilPolicies">
            <ng-template [ngIf]="employeeToilPolicies.value">
                <div class="policies-container">
                    <p class="no-data" *ngIf="employeeToilPolicies.value.data.length === 0" appLocalizationPopupDirective localizationCode="NoPolicies">{{ 'NoPolicies' | translate: {Default: "No Policies"} }}</p>
        
                    <ng-container *ngFor="let employeeToilPolicy of employeeToilPolicies.value.data" >
                        <mat-card class="policy main-container" appearance="outlined">
                            <div class="top">
                                <div class="title">
                                    <!-- <img *ngIf="timeOffType.image" [src]="getIcon(employeeToilPolicy.toilPolicy?.toilType?.id) | async" class="timeoff-type-icon"/> -->
        
                                    <h4 [title]="employeeToilPolicy.toilPolicy?.toilType?.name">{{employeeToilPolicy.toilPolicy?.toilType?.name}}</h4>
                                    <p [title]="employeeToilPolicy.toilPolicy?.name">{{employeeToilPolicy.toilPolicy?.name}}</p>
                                </div>

                                <div class="admin-controls" *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj, tableDeleteAccessObj]">
                                    <button
                                        class="settings-button"
                                        mat-icon-button
                                        type="button"
                                        [matMenuTriggerFor]="settings"
                                        [attr.aria-label]="(employeeToilPolicy.toilPolicy?.toilType?.name || '') + ' ' + ('Options' | translate: {Default: 'options'})"
                                    >
                                        <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
                                    </button>
                                    <mat-menu #settings="matMenu" xPosition="before">
                                        <button class="settings-menu__item" appPreventDoubleClick (throttledClick)="openConfirmDeleteDialog(employeeToilPolicy)" mat-menu-item *appTableAccess="[tableDeleteAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeToilPolicyDelete">
                                            <mat-icon class="material-icons-outlined">delete</mat-icon>
                                            {{ 'EmployeeToilPolicyDelete' | translate: {Default: "Delete"} }}
                                        </button>
                                        <button class="settings-menu__item" mat-menu-item appPreventDoubleClick (throttledClick)="openModifyBalanceFormDialog(employeeToilPolicy)" *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeModifyBalance">
                                            <mat-icon class="material-icons-outlined">settings</mat-icon>
                                            {{ 'EmployeeTimeOffTypeModifyBalance' | translate: {Default: "Modify Balance"} }}
                                        </button>
                                        <button class="settings-menu__item" mat-menu-item appPreventDoubleClick (throttledClick)="openCalculationLogDialog(employeeToilPolicy)" *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeCalculationLog">
                                            <mat-icon class="material-icons-outlined">calculate</mat-icon>
                                            {{ 'EmployeeTimeOffTypeCalculationLog' | translate: {Default: "Calculation Log"} }}
                                        </button>
                                    </mat-menu>
                                </div>
                            </div>
                            <div class="balance-container">
                                <div class="label">
                                    <h6 appLocalizationPopupDirective localizationCode="EmployeeToilPolicyBalance">
                                        {{ 'EmployeeToilPolicyBalance' | translate: {Default: "Balance"} }}
                                    </h6>
                                </div>
                                <div class="balance">
                                    <ng-container *ngIf="employeeToilPolicy.availableHours; else noAvailableHours">
                                        <span class="balance-value" setColor="primaryColour">{{employeeToilPolicy.availableHours | number:'1.2-2' }}</span>
                                    </ng-container>
                                    <ng-template #noAvailableHours>
                                        <span class="balance-value" setColor="primaryColour">0</span>
                                    </ng-template>
                                </div>
                                <div class="hours">
                                    <h6 appLocalizationPopupDirective localizationCode="EmployeeToilPolicyHours">
                                        {{ 'EmployeeToilPolicyHours' | translate: {Default: "Hours"} }}
                                    </h6>
                                </div>
                            </div>
                        </mat-card>
                    </ng-container>

                </div>
            </ng-template>
        
            <ng-template [ngIf]="employeeToilPolicies.error">Error</ng-template>
            <ng-template [ngIf]="employeeToilPolicies.loading">
                <ngx-skeleton-loader
                    count="5"
                    [theme]="{
                        'height.px': 50
                    }"
                ></ngx-skeleton-loader>
            </ng-template>
        </div>
    </mat-card-content>
</mat-card>



